<script setup>
import { Document,CloseBold } from "@element-plus/icons-vue"
    let dataFile = [];
    
    const props = defineProps([ 'currentMail', 'rawHtml' ]);
    const uploadDir = WmlGlobalVar.upload_dir;
</script>

<template>
    
    <div class="wml-mail-preview">
        <el-input v-model="currentMail.sent_date" disabled>
            <template #prepend>Sent Date:</template>
        </el-input>

        <el-input v-model="currentMail.to_email" disabled>
            <template #prepend>To:</template>
        </el-input>

        <el-input v-model="currentMail.subject" disabled>
            <template #prepend>Subject:</template>
        </el-input>
        
        <el-collapse model-value="content" >
            <el-collapse-item title="Mail Content" name="content">
                <div class="wml-body-wrapper" v-if="rawHtml">{{ currentMail.message }}</div>
                <div class="wml-body-wrapper" v-else v-html="currentMail.message"></div>
            </el-collapse-item>
            <el-collapse-item v-if="currentMail.attachments == 'true'" title="Attachments" name="attachments" class="wml-attach-files">

                <el-tooltip
                    class="box-item"
                    effect="dark"
                    :content="file.exist ? file.name : file.name + ' File not exist'"
                    placement="top"
                    v-for="(file,index) in currentMail.dataFile" :key="index"
                >
                <a :href=" file.exist ? uploadDir + file.path : '#'" :target=" file.exist ? '_blank' : ''">
                    <el-icon v-if="file.exist"><Document /></el-icon>
                    <el-icon v-else><CloseBold /></el-icon>
                </a>
                </el-tooltip>
            </el-collapse-item>
            <el-collapse-item title="Headers" name="header">
                <div class="info-item">
                    {{ currentMail.headers }}
                </div>
            </el-collapse-item>
        </el-collapse>
            
    </div>
</template>